import { useDebounceFn } from '@baidu/trade-util/hooks';
import { defineComponent, ref, onMounted, onUpdated, onUnmounted, openBlock, createElementBlock, createElementVNode, normalizeClass, normalizeStyle, withDirectives, vShow, toDisplayString, createCommentVNode, renderSlot } from 'vue';
import { foldTextProps } from './fold-text2.js';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.js';

const _sfc_main = defineComponent({
  name: "FoldText",
  props: foldTextProps,
  setup() {
    const contentDomRef = ref();
    const contentOriginLayout = { width: 0, height: 0 };
    const showFoldHandle = ref(false);
    const isFolded = ref(true);
    const contentLineHeight = ref("0px");
    const computeTextOriginLayout = () => {
      const oContent = contentDomRef.value;
      if (oContent) {
        const range = document.createRange();
        range.setStart(oContent, 0);
        range.setEnd(oContent, oContent.childNodes.length);
        const rangeWidth = range.getBoundingClientRect().width;
        const rangeHeight = range.getBoundingClientRect().height;
        contentOriginLayout.width = rangeWidth;
        contentOriginLayout.height = rangeHeight;
        contentLineHeight.value = getComputedStyle(oContent).lineHeight;
      }
    };
    const judgedShouldShowFoldHandle = (shouldReComputedLayout) => {
      if (shouldReComputedLayout) {
        computeTextOriginLayout();
      }
      if (contentDomRef.value) {
        const computedLayout = contentDomRef.value.getBoundingClientRect();
        const { width: currentWith, height: currentHeight } = computedLayout;
        if (currentHeight < contentOriginLayout.height || currentWith < contentOriginLayout.width || !isFolded.value) {
          showFoldHandle.value = true;
        } else {
          showFoldHandle.value = false;
        }
      }
    };
    const { run: judgedShouldShowFoldHandleDebounce } = useDebounceFn(judgedShouldShowFoldHandle, { wait: 500 });
    const onWindowResize = () => {
      judgedShouldShowFoldHandleDebounce(true);
    };
    let contentDomResizeObserver;
    if (ResizeObserver) {
      contentDomResizeObserver = new ResizeObserver(onWindowResize);
    }
    onMounted(() => {
      computeTextOriginLayout();
      judgedShouldShowFoldHandle(false);
      if (contentDomRef.value && contentDomResizeObserver) {
        contentDomResizeObserver.observe(contentDomRef.value);
      } else {
        window.addEventListener("resize", onWindowResize);
      }
    });
    onUpdated(() => {
      computeTextOriginLayout();
      judgedShouldShowFoldHandle(false);
    });
    onUnmounted(() => {
      if (contentDomResizeObserver) {
        contentDomResizeObserver.disconnect();
      } else {
        window.removeEventListener("resize", onWindowResize);
      }
    });
    return {
      contentDomRef,
      showFoldHandle,
      isFolded,
      contentLineHeight
    };
  }
});
const _hoisted_1 = { class: "t-fold-text" };
const _hoisted_2 = ["line-clamp"];
const _hoisted_3 = { class: "ellipsis" };
const _hoisted_4 = { class: "text" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", {
      ref: "contentDomRef",
      class: normalizeClass(["t-fold-text__content", _ctx.isFolded ? "folded" : null]),
      "line-clamp": _ctx.line,
      style: normalizeStyle({
        ..._ctx.isFolded ? { maxHeight: `calc(${_ctx.contentLineHeight} * ${_ctx.line})` } : {}
      })
    }, [
      createElementVNode("span", {
        class: "t-fold-text__handle-placeholder",
        style: normalizeStyle({
          marginBottom: `-${_ctx.contentLineHeight}`
        })
      }, null, 4),
      _ctx.showFoldHandle ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "t-fold-text__handle",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.isFolded = !_ctx.isFolded)
      }, [
        withDirectives(createElementVNode("span", _hoisted_3, "...", 512), [
          [vShow, _ctx.isFolded]
        ]),
        createElementVNode("span", _hoisted_4, toDisplayString(_ctx.isFolded ? "\u5C55\u5F00" : "\u6536\u8D77"), 1)
      ])) : createCommentVNode("v-if", true),
      createCommentVNode(" @slot \u6587\u672C\u5185\u5BB9\uFF0Cslot \u5185\u5BB9\u4EC5\u9650\u6587\u672C\u8282\u70B9 "),
      renderSlot(_ctx.$slots, "default")
    ], 14, _hoisted_2)
  ]);
}
var FoldText = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/b2b-fe-repository/trade-ui/packages/components/fold-text/src/fold-text.vue"]]);

export { FoldText as default };
//# sourceMappingURL=fold-text.vue2.js.map
